<template>
  <div class="pdf-box relative">
    <div class="view-box center"
         v-loading="firstLoading"
         v-if="boxReload"
         @scroll="changeView"
         ref="pdfView"
         v-infinite-scroll="scrollLoad"
         :infinite-scroll-distance="200">
      <canvas class="the-canvas" v-for="item in loadedPage" :key="item"></canvas>
      <div v-if="loading&&!firstLoading" class="center loading-box">
        <i class="el-icon-loading font36"></i>
      </div>
    </div>
    <div class="operate-box">
      <i class="iconfont icon-quanpingzuidahua left pointer mr15"
         v-if="showFullBtn" @click="fullScreen"></i>
      <i class="iconfont icon-suoxiao left mr15 pointer" @click="shrinkPdf"></i>
      <span class="left mr15">{{ scaleNum }}%</span>
      <i class="iconfont icon-fangda left pointer" @click="amplifyPdf"></i>
      <el-button class="left first-btn"
                 type="primary"
                 size="mini" @click="backIndex">回到首页</el-button>
      <div class="left prev-btn" @click="prevPage">《上一页</div>
      <div class="left next-btn ml5" @click="nextPage">下一页》</div>
      <el-input v-model="nowPage"
                size="mini" class="ml10" @keydown.enter.native="turnPage"></el-input>/{{ total }}
      <el-button type="primary" plain size="mini" @click="turnPage">跳 转</el-button>
      <el-button type="danger" class="down-btn" @click="downPdf">全文下载</el-button>
    </div>
  </div>
</template>

<script>
import pdfjsLib from 'pdfjs-dist/build/pdf';
// import { DRCNET_BASE_URL } from '../config';
import { $dg_getPdf } from '../api';
import { login, loginOut } from '../utils';

export default {
  name: 'PdfPreview',
  data() {
    return {
      pdf: null,
      total: 1,
      nowPage: 1,
      pageHeight: 0,
      isOpen: false,
      scale: 1,
      pdfSrc: '',
      pageSize: 10,
      startIndex: 1, // 开始的下标+1
      loading: false,
      loadedPage: 0, // 已经加载的页面数
      isFirst: true,
      boxReload: true,
      initPageSize: 10,
    };
  },
  props: {
    code: {
      default: () => '',
      type: String,
    },
    fileId: {
      default: () => '',
      type: String,
    },
    fileName: {
      default: () => '',
      type: String,
    },
  },
  watch: {
  },
  computed: {
    showFullBtn() {
      if (document.documentElement.requestFullscreen) return true;
      return false;
    },
    scaleNum() {
      return this.scale * 100;
    },
    token() {
      return this.$store.state.userToken;
    },
    firstLoading() {
      return this.isFirst && this.loading;
    },
  },
  methods: {
    downPdf() {
      const {
        code, fileId, fileName,
      } = this;
      let { token } = this;
      if (!fileId) return;
      if (fileId === '') return;
      if (!code) return;
      if (code === '') return;
      if (!token) token = 'notLogin';
      window.open(`/bigdata/getFile/${fileId}/${code}/${token}/${fileName}`);
    },
    async getPdfUrl() {
      let { pageSize, startIndex } = this;
      const {
        code, fileId, token,
        // isFirst, total,
      } = this;
      if (!code) return;
      if (!fileId) return;
      if (!token) pageSize = 5;
      this.loading = true;
      startIndex = 1 + ((startIndex - 1) * pageSize);
      // if (pageSize + startIndex > total && !isFirst) {
      //   pageSize = total - startIndex + 1;
      // }
      const resp = await $dg_getPdf({
        code,
        fileId,
        token,
        startIndex,
        pageSize,
      });
      this.total = resp.total;
      if (!resp.hasRight && !token) {
        this.$message.info('个人用户仅支持预览5页');
        this.total = 5;
      } else if (!resp.hasRight) {
        loginOut(this.$route.query, 'detail');
        return;
      }
      // 如果超过最大页码则设置为最大页码，没有超出就从上次的加上pageSize
      this.loadedPage = this.loadedPage + pageSize > this.total
        ? this.total : this.loadedPage + pageSize;
      try {
        await this.formatPdfData(resp.file);
        if (!token) {
          await this.$confirm('登录即可查看原文，是否前往登录？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'info',
          });
          login();
        }
      } catch (e) {
        if (e.message === 'browser not support') {
          this.$message({
            message: '浏览器暂不支持pdf预览，请接收pdf自动下载',
            type: 'info',
            duration: 0,
            showClose: true,
          });
        }
      } finally {
        this.loading = false;
        this.isFirst = false; // 请求一次过后就将其设置为false
      }
    },
    async formatPdfData(base) {
      const decodedData = window.atob(base);// 将得到的base64重新编码
      const rawLength = decodedData.length;
      const array = new Uint8Array(new ArrayBuffer(rawLength));
      for (let i = 0; i < rawLength; i += 1) {
        array[i] = decodedData.charCodeAt(i) & 0xff;
      }
      await this.translatePdf(array);// 将得到的bytes数组转译为canvas图片展示pdf
    },
    async translatePdf(url) {
      try {
        this.pdf = await pdfjsLib.getDocument(url);
        // 在dom重新构建之后再执行pdf的渲染
        this.$nextTick(() => {
          this.getPdfPage();
        });
        return Promise.resolve('success');
      } catch (e) {
        this.downPdf();
        return Promise.reject(new Error('browser not support'));
      }
    },
    getPdfPage(scale = 1) {
      const {
        pdf, pageSize, startIndex,
      } = this;
      const canvasArr = document.getElementsByClassName('the-canvas');
      // 取出这一次渲染的开始下标
      const start = pageSize * (startIndex - 1);
      // 取出这次需要绘出pdf的canvas节点数组
      const arr = Array.from(canvasArr)
        .slice(start, start + pageSize);
      arr.forEach(async (item, index) => {
        const canvas = arr[index];
        const page = await pdf.getPage(index + 1); // 调用pdfjs转译对应的canvas
        const originalViewport = page.getViewport(1);
        const finalScale = 835 / originalViewport.width * scale;
        const viewport = page.getViewport(finalScale);
        const canvasContext = canvas.getContext('2d');
        this.pageHeight = Math.floor(viewport.height); // 将每一页的高度计算出来
        canvas.height = viewport.height;
        canvas.width = viewport.width;
        const renderContext = {
          canvasContext,
          viewport,
        };
        await page.render(renderContext);
        // 得到pdf单页内容后调用切换到选中的页码
        this.changeNum();
      });
    },
    backIndex() {
      this.nowPage = 1;
      this.changeNum();
    },
    prevPage() {
      if (this.nowPage === 1) {
        this.$message.warning('当前已经是第一页');
        return;
      }
      this.nowPage = +this.nowPage - 1;
      this.changeNum();
    },
    nextPage() {
      if (this.nowPage === this.total) {
        this.$message.warning('当前已经是最后一页');
        return;
      }
      this.nowPage = +this.nowPage + 1;
      this.changeNum();
    },
    changeNum() {
      const {
        nowPage, pageHeight, $refs, total,
      } = this;
      const page = +nowPage;
      if (page > total) {
        this.nowPage = total;
        this.changeNum();
        return;
      }
      if (page < 1) {
        this.nowPage = 1;
        this.changeNum();
        return;
      }
      $refs.pdfView.scrollTop = Math.floor((page - 1) * pageHeight);
    },
    changeView() {
      const { pageHeight, total } = this;
      const top = this.$refs.pdfView.scrollTop;
      let page = Math.floor(top / pageHeight) + 1;
      if (!page) page = 1;
      if (page > total) page = total;
      this.nowPage = page;
    },
    fullScreen() {
      const dom = document.documentElement;
      const open_list = ['requestFullscreen', 'mozRequestFullScreen', 'webkitRequestFullScreen', 'msRequestFullscreen'];
      const cancel_list = ['exitFullscreen', 'mozCancelFullScreen', 'webkitCancelFullScreen'];
      const { isOpen } = this;
      let fn;
      if (!isOpen) {
        fn = open_list.find(v => dom[v]);
        if (fn) {
          dom[fn]();
          this.isOpen = true;
        }
      } else {
        fn = cancel_list.find(v => dom[v]);
        if (fn) {
          dom[fn]();
          this.isOpen = false;
        }
      }
    },
    shrinkPdf() {
      if (this.scale === 0.1) return;
      this.scale = this.formatNumber(+this.scale - 0.2);
      this.getPdfPage(this.scale);
    },
    amplifyPdf() {
      if (this.scale === 2) return;
      this.scale = this.formatNumber(+this.scale + 0.2);
      this.getPdfPage(this.scale);
    },
    scrollLoad() {
      const {
        nowPage, total, loadedPage, loading, initPageSize,
      } = this;
      if (loading) return;
      if (loadedPage >= total) return;
      if (nowPage < total && nowPage >= loadedPage - 1) {
        // 因为输入跳转可能导致pageSize为输入的值，在滚动时重新计算startIndex和pageSize
        this.pageSize = this.initPageSize;
        this.startIndex = Math.ceil(loadedPage / initPageSize) + 1;
        this.getPdfUrl();
      }
    },
    async turnPage() {
      const { loadedPage, total, initPageSize } = this;
      if (+this.nowPage > total) this.nowPage = total;
      if (+this.nowPage < 1) this.nowPage = 1;
      if (Number.isNaN(+this.nowPage)) this.nowPage = 1;
      if (+this.nowPage > loadedPage) {
        this.loadedPage = 0;
        this.startIndex = 1;
        const numPage = Number(this.nowPage);
        let page = numPage + initPageSize - (numPage % initPageSize);
        if (page > total) {
          page = total;
        }
        this.pageSize = page;
        // 如果输入值是未加载的直接调整成整页加载的效果，并且删除所有已加载的pdf。重新加载新的pdf文件
        this.isFirst = true;
        this.boxReload = false;
        this.$nextTick(() => {
          this.boxReload = true;
        });
        await this.getPdfUrl();
      } else {
        // 输入值是已经加载过的页面就直接滚动到页面的位置
        this.changeNum();
      }
    },
  },
  mounted() {
    this.getPdfUrl();
  },
};
</script>

<style scoped lang="scss">
@import "@/scss/var.scss";
.pdf-box{
  width: 850px;
  height: 672px;
  border: 1px solid #222222;
  .loading-box{
    height: 80px;
    line-height: 80px;
  }
  .view-box{
    height: 632px;
    overflow-y: auto;
  }
  .operate-box{
    height: 40px;
    line-height: 40px;
    padding-left: 50px;
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
  }
  /deep/
  .el-input{
    text-align: center;
    width: 30px;
    .el-input__inner{
      padding: 0 5px;
    }
  }
  /deep/
  .el-button--mini{
    padding: 7px 5px;
  }
  .down-btn{
    width: 96px;
    height: 38px;
    padding: 0;
    float: right;
  }
  .iconfont{
    &:hover{
      color: $--primary-color;
    }
  }
  .icon-quanpingzuidahua{
    font-size: 20px;
  }
  .icon-suoxiao{
    font-size: 20px;
  }
  .icon-fangda{
    font-size: 22px;
  }
  @mixin btnBorder{
    padding: 4px 8px 4px 4px;
    border: 1px solid #C7C7C7;
    line-height: 1;
    margin-top: 8px;
    cursor: pointer;
    &:hover{
      color: $--primary-color;
      border-color: $--primary-color;
    }
  }
  .first-btn{
    margin-left: 230px;
    margin-top: 7px;
    margin-right: 5px;
  }
  .prev-btn{
    @include btnBorder;
  }
  .next-btn{
    @include btnBorder;
  }
}
</style>
